import React, { memo } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { CheckboxProps } from './types';

const CheckBox: React.FC<CheckboxProps> = ({ label, checked, ...rest }) => {
  return <FormControlLabel {...rest} control={<Checkbox checked={checked} />} label={label} />;
};

export default memo(CheckBox);
